<script>
	import Data from '../../States/Data';
	import Helper from '../../Models/Helper';
	import Slider from '../../States/Slider';

	export let query = '';
	export let host = 'search';

	let input = {};
	let mapping = {};
	let unique = {};
	let last_input = '';
	let timeout = 0;
	let suggestion = {};

	async function init() {
		mapping = await Data.absolute('mapping');
		unique = await Data.relative('search/unique');
		resetSuggestion();
	}

	function suggest() {
		const proceed = () => {
			let value = input.value.trim();
			value = Helper.normalize(value);
			if (value.length >= 3) {
				if (last_input !== value) {
					last_input = value;
					const match = value.match(/([^\s]+)$/);
					if (match) {
						resetSuggestion();
						const suffix = match[1];
						suggestBooks(value, suffix);
						suggestWords(value, suffix);
					}
				}
			}
			else resetSuggestion();
		};

		if (Helper.is(mapping) && Helper.is(unique)) {
			clearTimeout(timeout);
			timeout = setTimeout(proceed, 100);
		}
	}

	function resetSuggestion() {
		suggestion = {books: [], words: []};
	}

	function suggestBooks(complete, suffix) {
		const query = complete.replace(/[0-9\:\-]/g, '').trim();
		const pattern = new RegExp(`${query}`, 'i');
		for (let book in mapping.books) {
			let plain = mapping.books[book][0];
			plain = Helper.normalize(plain);
			if (pattern.test(plain)) {
				let location = '';
				if (complete != suffix) {
					const specific = complete.match(/([0-9\:\-]+)$/);
					if (specific)
						location = specific[1];
				}

				if (location)
					plain += ` ${location}`;

				const html = Helper.highlight(plain, complete);
				suggestion.books.push({html, plain, book, location});
			}
		}
	}

	function suggestWords(complete, suffix) {
		if (suffix.length > 1) {
			const pattern = new RegExp(`^${suffix}`, 'i');
			for (let option of unique)
				if (pattern.test(option)) {
					const html = Helper.highlight(option, suffix);
					suggestion.words.push({html, plain: option});
				}
		}
	}

	function search() {
		clearTimeout(timeout);
		input.blur();
		const query = input.value.trim();
		resetSuggestion();
		Slider.search(query);
	}

	function keyUp(event) {
		const submit = event.key.toLowerCase() === 'enter';
		if (submit) search();
		else suggest();
	}

	function suggestedBook(book) {
		let chapter = 1;
		if (book.location) {
			const match = book.location.match(/^([0-9]+)/);
			if (match) chapter = match[1];
		}

		const location = `${book.book}_${chapter}`;
		Slider.route(['chapter', [location]]);
	}

	function suggestedWord(word) {
		let value = input.value.trim();
		value = value.replace(/([^\s]+)$/, word.plain);
		input.value = value;
		search();
	}

	init();
</script>

<style>
	div.input {
		display: flex;
		flex-direction: row;
		padding-bottom: .5em;
	}

	div.input input {
		font-size: 1.25em;
		font-weight: bold;
		margin-right: .5em;
	}

	div.input div.button {
		display: inline-block;
		color: var(--box-background-focus);
		margin: 0;
		border: none;
		background: var(--primary-color);
	}

	div.input div.button i {
		margin-top: .35em;
		font-size: 1.8em;
	}

	div.below-input {
		padding-top: 1em;
	}

	div.suggestion.list {
		padding: .5em 1em;
		border-radius: .3em;
		background-color: var(--box-background-focus);
		max-height: 25em;
		overflow: hidden;
		overflow-y: scroll;
		overflow: -moz-scrollbars-none;
		-ms-overflow-style: none;
	}

	div.suggestion.list::-webkit-scrollbar {
	    display: none;
	}

	div.suggestion.list div.item {
		font-size: 1em;
		padding-bottom: .25em;
	}

	div.suggestion.list div.item i {
		margin-top: .65em;
	}

	/* Hosts */

	div.host-start div.input input {
		background-color: var(--box-background-light);
	}

	div.host-start div.input div.button {
		color: var(--primary-color);
		border: 1px solid var(--primary-background-light);
		background: var(--box-background-light);
	}

	div.host-start div.below-input {
		padding-top: .5em;
	}

	div.host-start h3 {
		font-size: .7em;
		text-transform: uppercase;
	}

	div.host-start div.suggestion.list {
		background-color: var(--primary-background-light);
	}
</style>

<div class="host-{host}">
	<div class="input">
		<input type="text" name="search" bind:this="{input}" on:keyup="{keyUp}" value="{query || ''}" placeholder="{Helper.smallScreen() ? 'Zoeken...' : 'Zoeken in de bijbel...'}"/>
		<div class="button" on:click="{event => search()}">
			<i class="fas fa-search"></i>
		</div>
	</div>
	<div class="below-input">
		{#if Helper.is(suggestion.books)}
			<h3 class="solid list">Gevonden boeken</h3>
			<div class="suggestion list">
				{#each suggestion.books as book}
					<div class="item item-icon-left" on:click="{event => suggestedBook(book)}">
						<i class="fad fa-share"></i>
						<div>{@html book.html}</div>
					</div>
				{/each}
			</div>
		{/if}
		{#if Helper.is(suggestion.words)}
			<h3 class="solid list">Gevonden woorden</h3>
			<div class="suggestion list">
				{#each suggestion.words as word}
					<div class="item" on:click="{event => suggestedWord(word)}">
						<i class="fad fa-tags"></i>
						<div>{@html word.html}</div>
					</div>
				{/each}
			</div>
		{/if}
	</div>
</div>